import { render, staticRenderFns } from "./DetailIndustrialProperty.vue?vue&type=template&id=5ce1c3dc"
import script from "./DetailIndustrialProperty.vue?vue&type=script&lang=js"
export * from "./DetailIndustrialProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports